export default __webpack_public_path__ + "static/media/Juno.d7ea3773.webp";